import { gql } from "@urql/core";

export const DEFAULT_COMMITTEE_LIST_QUERY = gql`
  query DefaultCommitteeList(
    $filter: JSONObject
    $sorting: [SortInput!]
    $paging: PaginationInput
  ) {
    defaultCommittees(query: { filter: $filter, sorting: $sorting, paging: $paging }) {
      nodes {
        id
        name
        applicableMinuteTypes
        members {
          fullName
          role
          organization
          linkedUserId
          isActive
        }
        isActive
        createdAt
        updatedAt
      }
    }
  }
`;

export const DEFAULT_COMMITTEE_ONE_QUERY = gql`
  query DefaultCommitteeOne($id: ID!) {
    defaultCommittee(id: $id) {
      id
      name
      applicableMinuteTypes
      members {
        fullName
        role
        organization
        linkedUserId
        isActive
      }
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_DEFAULT_COMMITTEE_MUTATION = gql`
  mutation CreateDefaultCommittee($input: CreateDefaultCommitteeInput!) {
    createDefaultCommittee(input: $input) {
      id
      name
      applicableMinuteTypes
      members {
        fullName
        role
        organization
        linkedUserId
        isActive
      }
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_DEFAULT_COMMITTEE_MUTATION = gql`
  mutation UpdateDefaultCommittee($id: ID!, $input: UpdateDefaultCommitteeInput!) {
    updateDefaultCommittee(id: $id, input: $input) {
      id
      name
      applicableMinuteTypes
      members {
        fullName
        role
        organization
        linkedUserId
        isActive
      }
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_DEFAULT_COMMITTEE_MUTATION = gql`
  mutation DeleteDefaultCommittee($id: ID!) {
    deleteDefaultCommittee(id: $id) {
      id
    }
  }
`;
